import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';

export type FlowMediaAgentState = {
  /** The flow may use a media agent (entitlement). */
  entitled: boolean;
  /** Operator switch in the configuration tab. */
  enabled: boolean;
  /** Bookings, backup slides and recovery run only when true. */
  active: boolean;
};

export const GET_FLOW_MEDIA_AGENT_QUERY_KEY = 'flow-media-agent';

export function useGetFlowMediaAgentQuery(flowId?: string) {
  const { getToken } = useAuth();
  return useQuery({
    queryKey: [GET_FLOW_MEDIA_AGENT_QUERY_KEY, flowId],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/flows/${flowId}/playout/media-agent`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? '' }) as Promise<FlowMediaAgentState>;
    },
    enabled: !!flowId,
  });
}
